import { path } from "ramda"
import { getStatusFor } from "../../utils/curriculum-helper"
import {
  isAssociateTrack,
  isPendingAssociate,
  isStudent,
  getProgramTypeCode,
} from "../../utils/index"

export const visibilityFilter = link => !link.hidden

export const currentProgram = user => link => {
  // CourseCurriculum status map is AP/ST/PQ/QE only; treat PA like AP for link filters
  const statusType = isPendingAssociate(user) ? "AP" : getProgramTypeCode(user)
  const status =
    isStudent(user) || isAssociateTrack(user)
      ? getStatusFor(statusType, path(["education", "currentLevel"], user))
      : ""
  return link.program ? status === link.program[0] : true
}
